export const ALIGNMENTS = ['left', 'center', 'right']
export const SORT_DIRECTIONS = ['asc', 'desc', 'default']
export const SECTIONS = ['none', 'head', 'body']
